define([
	"dojo/_base/array",
	"dojo/_base/declare",
	"csi/data/AbstractPathBrowserStore",
	"csi/locale",
	"csi/prefs/BrowseAttributesStoreOptions"
], function(array,declare,AbstractPathBrowserStore,locale,BrowseAttributesStoreOptions) {

function rcComparator(rc1,rc2) {
	var val1 = locale.type(rc1.getType());
	var val2 = locale.type(rc2.getType());
	return val1.localeCompare(val2);
}

return declare(AbstractPathBrowserStore,
	{
		comparatorMap: {
			rc: rcComparator,
			rcOriginal: rcComparator
		},

		newOptionsInstance: function() {
			return new BrowseAttributesStoreOptions();
		},

		getItemsFromRC: function(/*csi.data.ExtendedPath*/path,/*csi.reflection.Class*/rcFromPath) {
			var items = this.inherited(arguments);

			// include attributes
			array.forEach(rcFromPath.getAttributes(true,true,true),function(ra){
				var id = ra.getId();

				var item = {
					_store: this,
					extendedPath: path,
					rcOriginal: rcFromPath,
					rc: ra.getOwner(),
					ra: ra,
					localId: id,
					text: id,
					value: id
				};

				items.push(item);
			},this);

			// Filter out some attributes.
			// Remove hidden and disabled items by default.
			items = array.filter(items,this.options.filterItem,this.options);

			// localize text for all items
			array.forEach(items,function(item){
				var rc = item.rc;
				var id = item.value;
				if (item.ra)
					item.text = locale.typeId(rc.getType(),id);
				else
					item.text = locale.resource(id);
			},this);

			return items;
		}
	}
);

});